<template>
  <div class="position-relative">
    <validating-group
      :validation-context="validationContext"
      :validation-path="inputName"
      :rules="validationRules"
      v-slot="{ clearErrors, state }"
    >
      <date-picker
        :class="['my-2', { 'is-invalid': state === false }]"
        :readonly="readonly"
        :value="valueMoment"
        :config="date_options"
        @dp-change="
          updateDate($event);
          clearErrors();
        "
      />
    </validating-group>
    <p v-if="Boolean(hint)" class="text-muted">{{ hint }}</p>
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue-bootstrap-datetimepicker';
import BaseInput from './mixins/BaseInput';
import ValidatingInput from '../mixins/ValidatingInput';
import { READINESS_DATE } from './_types';

export default {
  mixins: [BaseInput, ValidatingInput],
  components: {
    DatePicker,
  },
  props: {
    hint: String,
    inputName: {
      type: String,
      default: READINESS_DATE,
    },
    onlyAfterDate: {
      type: [Object, Boolean],
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      date_options: {
        format: 'L',
        locale: moment.locale(),
        minDate: this.onlyAfterDate,
        icons: {
          time: 'material-icons access_time',
          date: 'material-icons date_range',
          up: 'material-icons keyboard_arrow_up',
          down: 'material-icons keyboard_arrow_down',
          previous: 'material-icons keyboard_arrow_left',
          next: 'material-icons keyboard_arrow_right',
          today: 'material-icons today',
          clear: 'material-icons clear',
          close: 'material-icons close',
        },
      },
    };
  },
  computed: {
    valueMoment() {
      const value = this.$store.getters.jobInputValue(
        this.jobId,
        this.inputName,
      );
      return value ? moment(value).format(this.date_options.format) : '';
    },
  },
  methods: {
    updateDate(event) {
      const time = event.date
        ? event.date.startOf('day').toISOString(true)
        : null;
      this.commitValue(time);
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/_datetimepicker.scss';
</style>
